
function fadeInHeader() {
  document.querySelectorAll(`[data-header-fade-in]`).forEach((element) => {
    element.style.opacity = 1;
  });
}

export default fadeInHeader;
